import { render, staticRenderFns } from "./readonly-editor.vue?vue&type=template&id=59d799df&scoped=true&"
import script from "./readonly-editor.vue?vue&type=script&lang=js&"
export * from "./readonly-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d799df",
  null
  
)

export default component.exports